import { render, staticRenderFns } from "./LevelAdjustmentCreate.vue?vue&type=template&id=87d1dd7a&"
import script from "./LevelAdjustmentCreate.vue?vue&type=script&lang=js&"
export * from "./LevelAdjustmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports